/* import __COLOCATED_TEMPLATE__ from './prism-phone-number-input.hbs'; */
import Component from '@ember/component';
// eslint-disable-next-line import/default
import FieldKit from 'field-kit';
import AuPhoneNumberFormatter from '../utils/formatters/au-phone-number-formatter';

// Removes formatting field-kit applies
const PHONE_NUMBER_NORMALIZE_REGEX = /([\s()+-])/g;

/**
 * This component renders a text input with phone number formatting.
 *
 * ```
 * {{prism-phone-number-input
 *   value=nameOfValueProperty
 *   inputId="my-id"
 *   inputClass="some-class some-other-class"
 *   placeholder="Put phone number here"
 *   countryCode="US"
 *   onChange=(action (mut nameOfValueProperty))}}
 * ```
 *
 * @class PrismPhoneNumberInput
 */
export default Component.extend({
  /**
   * ID to apply to the underlying input field.
   *
   * @argument inputId
   * @type {String}
   */
  inputId: null,
  /**
   * Class to apply to the underlying input field.
   *
   * @argument inputClass
   * @type {String}
   */
  inputClass: null,
  /**
   * Placeholder of the underlying input field.
   *
   * @argument placeholder
   * @type {String}
   */
  placeholder: null,
  /**
   * Country code to use for formatting. Defaults to US.
   *
   * @argument countryCode
   * @type {String}
   */
  countryCode: 'US',
  /**
   * The value passed. This is only relevant to set the initial value of the
   * field.
   *
   * @argument value
   * @type {String}
   */
  value: null,
  /**
   * An action that is called when the field is changed. The action is called
   * with the normalized phone number.
   *
   * @argument onChange
   * @type {Action}
   */
  onChange() {},
  // Internal value passed to the input.
  _internalValue: null,
  init(...args) {
    this._super(...args);
    this.set('_internalValue', this.value);
  },
  getFormatter() {
    if (this.countryCode === 'AU') {
      return new AuPhoneNumberFormatter();
    } else {
      return new FieldKit.PhoneFormatter();
    }
  },
  didInsertElement() {
    const formatter = this.getFormatter();
    this.set('field', new FieldKit.TextField(this.element.querySelector('input'), formatter));

    // Formats the field on creation if there is a pre-filled value.
    this.set('_internalValue', formatter.format(this.value));

    // FieldKit workaround, see https://github.com/square/field-kit/issues/62
    if (document.activeElement === this.field.element) {
      document.activeElement.blur();
    }
  },
  actions: {
    _onChange(event) {
      let value = event.target.value;
      value = value.replace(PHONE_NUMBER_NORMALIZE_REGEX, '');
      this.onChange(value);
    }
  }
});